import IMarkerBiuraClickedParams from '~/components/map/types/marker/IMarkerBiuraClickedParams';

import setActiveMarker from '../../shared/setActiveMarker';

const markerClicked = (params: IMarkerBiuraClickedParams) => {
  const {
    router,
    markerInfo: { activeMarker, marker },
  } = params;

  setActiveMarker(activeMarker, marker);
  router.push({
    path: `/biura${marker.Url}`,
  });
};
export default markerClicked;
